namespace Matrix.Data {
    export class DataDictionaryColumns {
        static columnsKey = 'Data.DataDictionary';
    }
}
